import { render, staticRenderFns } from "./WSuggestedDemandMaterials.vue?vue&type=template&id=15458513&scoped=true&"
import script from "./WSuggestedDemandMaterials.vue?vue&type=script&lang=js&"
export * from "./WSuggestedDemandMaterials.vue?vue&type=script&lang=js&"
import style0 from "./WSuggestedDemandMaterials.vue?vue&type=style&index=0&id=15458513&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15458513",
  null
  
)

export default component.exports